export default {
    path:'/how-it-works',
    preload:false,
    middlewares: []
  }